<template>
  <div>
    <a-row class="serachmenu" v-if="isSell">
      <a-col class="flexColumn" :span="8"></a-col>
      <a-col class="flexColumn" :span="4">
        <div
          class="house_list_order sort_5"
          :class="{
            cur1: sort === 5 && sortType == 'ASC',
            cur2: sort === 5 && sortType == 'DESC',
          }"
          @click="houselistsort(5)"
        >
          <span class="order_name">面积</span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
      <a-col class="flexColumn" :span="4">
        <div
          class="house_list_order sort_2"
          :class="{
            cur1: sort === 8 && sortType == 'ASC',
            cur2: sort === 8 && sortType == 'DESC',
          }"
          @click="houselistsort(8)"
        >
          <span class="order_name">单价</span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
        <div
          class="house_list_order sort_3"
          :class="{
            cur1: sort === 7 && sortType == 'ASC',
            cur2: sort === 7 && sortType == 'DESC',
          }"
          @click="houselistsort(7)"
        >
          <span class="order_name"> 售价 </span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
      <a-col class="flexColumn" :span="3">
        <div
          class="house_list_order sort_4"
          :class="{
            cur1: sort === 4 && sortType == 'ASC',
            cur2: sort === 4 && sortType == 'DESC',
          }"
        >
          <span class="order_name" @click="houselistsort(4)">带看</span>
          <a-select
            placeHolder="全部"
            :value="selectValue"
            class="order_select_region"
            @change="dateTypeChangeHandle"
          ><!--v-model="form.region"-->
            <a-select-option v-for="item in dateTypeOpts" :key="item.id" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
          <div class="icons" @click="houselistsort(4)">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
      <a-col class="flexColumn" :span="2"> </a-col>
      <a-col class="flexColumn" :span="4">
        <div
          class="house_list_order sort_6"
          :class="{
            cur1: sort === 6 && sortType == 'ASC',
            cur2: sort === 6 && sortType == 'DESC',
          }"
          @click="houselistsort(6)"
        >
          <span class="order_name">盘别</span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row class="serachmenu" v-else>
      <a-col class="flexColumn" :span="8"></a-col>
      <a-col class="flexColumn" :span="4">
        <div
          class="house_list_order sort_2"
          :class="{
            cur1: sort === 2 && sortType == 'ASC',
            cur2: sort === 2 && sortType == 'DESC',
          }"
          @click="houselistsort(2)"
        >
          <span class="order_name">面积</span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
      <a-col class="flexColumn" :span="4">
        <div
          class="house_list_order sort_3"
          :class="{
            cur1: sort === 3 && sortType == 'ASC',
            cur2: sort === 3 && sortType == 'DESC',
          }"
          @click="houselistsort(3)"
        >
          <span class="order_name">单价</span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
        <div
          class="house_list_order sort_5"
          :class="{
            cur1: sort === 5 && sortType == 'ASC',
            cur2: sort === 5 && sortType == 'DESC',
          }"
          @click="houselistsort(5)"
        >
          <span class="order_name">{{ isSell ? '售价' : '租价' }} </span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
      <a-col class="flexColumn" :span="3">
        <div
          class="house_list_order sort_4"
          :class="{
            cur1: sort === 4 && sortType == 'ASC',
            cur2: sort === 4 && sortType == 'DESC',
          }"
        >
          <span class="order_name" @click="houselistsort(4)">带看</span>
          <a-select
            placeHolder="全部"
            :value="selectValue"
            class="order_select_region"
            @change="dateTypeChangeHandle"
          ><!--v-model="form.region"-->
            <a-select-option v-for="item in dateTypeOpts" :key="item.id" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
          <div class="icons" @click="houselistsort(4)">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
      <a-col class="flexColumn" :span="2"> </a-col>
      <a-col class="flexColumn" :span="4">
        <div
          class="house_list_order sort_6"
          :class="{
            cur1: sort === 6 && sortType == 'ASC',
            cur2: sort === 6 && sortType == 'DESC',
          }"
          @click="houselistsort(6)"
        >
          <span class="order_name">盘别</span>
          <div class="icons">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </div>
        </div>
      </a-col>
    </a-row>
    <div v-if="isSell">
      <no-data v-if="records.length === 0"></no-data>
      <houseListSellVue :activeNum="activeNum" v-else :records="records"></houseListSellVue>
    </div>
    <div v-else>
      <no-data v-if="records.length === 0"></no-data>
      <houseListVue :activeNum="activeNum" v-else :records="records"></houseListVue>
    </div>
  </div>
</template>
<script>
import houseListSellVue from '@/components/houseList/houseSellList.vue'
import houseListVue from '@/components/houseList/houseList.vue'
export default {
  data () {
    return {
      selectValue: 7
    }
  },
  props: {
    isSell: {
      type: Boolean,
      default: true
    },
    dateTypeOpts: {
      type: Array,
      default: () => []
    },
    records: {
      type: Array,
      default: () => []
    },
    sort: {
      type: Number,
      default: 1
    },
    sortType: {
      type: String,
      default: ''
    },
    houseResourceType: {
      type: Number,
      default: 1
    },
    activeNum: {
      type: [String, Number],
      default: ''
    }
  },
  watch: {
    // 监听
    activeNum: {
      handler (val) {},
      immediate: true
    }
  },
  components: {
    houseListSellVue,
    houseListVue
  },
  methods: {
    houselistsort (val) {
      this.$emit('houselistsort', val)
    },
    dateTypeChangeHandle (e) {
      this.$emit('dateTypeChangeHandle', e)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.serachmenu {
  display: flex;
  align-items: center;
  float: right;
  margin-bottom: 30px;
  justify-content: space-between;
  color: #828282;
  font-size: 15px;
  font-weight: bold;
  padding-top: 20px;
  /* width: 820px;
      margin-right: -33px; */
  width: 100%;
  margin-right: 0;
}
.flexColumn {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.icons {
  display: flex;
  cursor: pointer;
  flex-wrap: wrap;
  width: 20px;
  height: 25px;
}
.order_name {
  margin-right: 10px;
  width: auto;
  cursor: pointer;
}
.cur1 {
  .order_name {
    color: var(--ThemeColor);
  }
  .icons i:nth-child(1) {
    color: var(--ThemeColor);
  }
}

.cur2 {
  .order_name {
    color: var(--ThemeColor);
  }
  .icons i:nth-child(2) {
    color: var(--ThemeColor);
  }
}
.order_select_region {
  margin-right: 10px;
}
.house_list_order {
  display: flex;
  align-items: center;
  /* width: 100%; */
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
.flexColumn {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
